export const deClientPortalOrderManagementSidebarPages = {
    orders: {
        orderManagementSidebar: {
            orderList: 'Auftragsliste',
        },
    },
}
